import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { IonSpinner } from '@ionic/angular/standalone';

@Component({
    selector: 'lib-loading-state',
    standalone: true,
    imports: [CommonModule, IonSpinner],
    templateUrl: './loading-state.component.html',
    styleUrl: './loading-state.component.css'
})
export class LoadingStateComponent {}
